import { IGetBannerParams, IGetHolidayBanner } from '@/types/dashboard';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';

export const cmsApiCaller = createApi({
  reducerPath: 'cmsApiCaller',
  refetchOnMountOrArgChange: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CMS_API_END_POINT,
  }),
  endpoints: (builder) => ({
    getHolidayBanner: builder.query<IGetHolidayBanner, IGetBannerParams>({
      query: (input) => {
        return {
          url: 'banner/active',
          method: 'GET',
          params: input,
        };
      },
    }),
  }),
});

export const { useGetHolidayBannerQuery } = cmsApiCaller;
